import { Children, isValidElement } from 'react';
var getChildKey = function getChildKey(child) {
  return child.key || "";
};
function onlyElements(children) {
  var filtered = [];
  // We use forEach here instead of map as map mutates the component key by preprending `.$`
  Children.forEach(children, function (child) {
    if (isValidElement(child)) filtered.push(child);
  });
  return filtered;
}
export { getChildKey, onlyElements };